import React, { useCallback, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Card, ListItem, ListItemText } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import AddIcon from "@material-ui/icons/Add";
import Container from "@material-ui/core/Container";
import List from "@material-ui/core/List";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import AddUserRoleDialog from "./AddUserRoleDialog";
import { useDeleteUserRole } from "./roleServices";
import ConfirmButton from "../components/ConfirmButton";

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: 400,
    padding: theme.spacing(3),
    margin: theme.spacing(1),
  },

  topBar: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: theme.spacing(3),
  },

  newButton: {
    textTransform: "uppercase",
    color: "#127DA9",
    fontSize: "1.2rem",
    fontWeight: "bold",
  },

  listItem: {
    borderBottomColor: theme.palette.primary.dark,
    borderBottomStyle: "dashed",
    borderBottomWidth: 1,
  },
}));

const UserRolesCard = ({ user, onAlert, onChange }) => {
  const classes = useStyles();

  const [dialogOpen, setDialogOpen] = useState(false);

  const deleteUserRole = useDeleteUserRole();
  const handleDeleteRole = useCallback(
    async roleName => {
      try {
        await deleteUserRole.mutateAsync({
          resourceIds: {
            id: user.userId,
            role: roleName,
          },
        });
        onChange();
      } catch (err) {
        onAlert("error", [err.message]);
      }
    },
    [deleteUserRole, user, onAlert, onChange],
  );

  const handleAddSuccess = useCallback(() => {
    onChange();
    setDialogOpen(false);
  }, [onChange]);

  const handleAddError = useCallback(
    error => {
      onAlert("error", [error.message]);
    },
    [onAlert],
  );

  return (
    <Card classes={{ root: classes.root }}>
      <AddUserRoleDialog
        open={dialogOpen}
        onCancel={useCallback(() => setDialogOpen(false), [])}
        onOk={handleAddSuccess}
        onError={handleAddError}
        user={user}
      />
      <Box className={classes.topBar}>
        <Box style={{ marginBottom: "10px" }}>
          <Typography variant="h2" color="primary" noWrap>
            User Roles
          </Typography>
        </Box>

        <Grid container spacing={3} direction="row" justify="flex-end">
          <Grid item>
            <Button
              variant={"text"}
              startIcon={<AddIcon />}
              classes={{ root: classes.newButton }}
              onClick={useCallback(() => setDialogOpen(true), [])}
            >
              Add User Role
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Container maxWidth={false}>
        <List dense={true}>
          {user.roles.map(role => (
            <ListItem classes={{ root: classes.listItem }} key={role.roleId}>
              <ListItemText primary={role.roleName} />
              <ListItemSecondaryAction>
                <ConfirmButton
                  handleDelete={() => handleDeleteRole(role.roleName)}
                  dialogTitle="Remove Role"
                  dialogBody="Are you sure you want to remove this role?"
                />
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Container>
    </Card>
  );
};

export default UserRolesCard;
